import React from 'react'

import MFASetup from 'components/auth/MFASetup'

const Account = () => {
  return <MFASetup />
}

export default Account
